"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerOverlay = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../../../Css");
// Small wrapper around DatePicker to provide necessary styling and state handling when displayed as an overlay.
function DatePickerOverlay({ overlayProps, children }) {
    return (
    // Adds `tabIndex` so clicking within the DatePicker will provide a `e.relatedTarget` on blur and focus events.
    // This allows for components such as the DateField to conditionally trigger their 'onBlur' prop. E.g. If the user leaves the field to interact with the DatePicker, then don't call onBlur
    (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.br4.bshModal.$, ...overlayProps, tabIndex: 0, children: children }));
}
exports.DatePickerOverlay = DatePickerOverlay;
